<template>
  <v-card>
    <v-tabs
      v-model="tab"
      bg-color="primary"
    >
      <v-tab v-if="auth.check('view dashboard planning')" value="calender">{{ $t('calenderView') }}</v-tab>
      <v-tab v-if="auth.check('view dashboard equipment maps')" value="map">{{ $t('mapView') }}</v-tab>
      <v-tab v-if="auth.check('view dashboard equipment maps')" value="search">{{ $t('searchView') }}</v-tab>
    </v-tabs>

    <v-card-text>
      <v-window v-model="tab">
        <v-window-item value="calender" :transition="false" :reverse-transition="false">
          <calender-view
            v-if="tab === 'calender' && auth.check('view dashboard planning')"
            ref="calenderView"
          />
        </v-window-item>
        <v-window-item value="map" :transition="false" :reverse-transition="false">
          <map-view
            v-if="tab === 'map' && auth.check('view dashboard equipment maps')"
            ref="mapView"
          />
        </v-window-item>
        <v-window-item value="search" :transition="false" :reverse-transition="false">
          <search-view
            v-if="tab === 'search' && auth.check('view dashboard equipment maps')"
            ref="searchView"
          />
        </v-window-item>
      </v-window>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue';
import CalenderView from '@/components/Dashboard/CalenderView.vue'
import MapView from '@/components/Dashboard/MapView.vue'
import SearchView from '@/components/Dashboard/SearchView.vue'
import store from '@/store';
import { useAuth } from '@/utils/auth'

const auth = useAuth()
const tab = ref<string | null>(null)

onBeforeMount(() => {
  if (auth.check('view dashboard planning')) {
    tab.value = 'calender'
  } else if (auth.check('view dashboard equipment maps')) {
    tab.value = 'map'
  } else {
    tab.value = null
  }

  store.commit('app.setPageTitle', 'Dashboard')
  store.commit('app.setBreadcrumbs', [])
})
</script>

<style lang="scss" scoped>
  .v-card {
    margin: 20px;
  }
  .v-tabs {
    color: #fff !important;
    background: #1E88E5 !important;
    font-weight: 400 !important;
    font-size: 24px !important;
  }
</style>
